import { render, staticRenderFns } from "./CeisaHsCodeDetail.vue?vue&type=template&id=134a8243&scoped=true&"
import script from "./CeisaHsCodeDetail.vue?vue&type=script&lang=js&"
export * from "./CeisaHsCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CeisaHsCodeDetail.vue?vue&type=style&index=0&id=134a8243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a8243",
  null
  
)

export default component.exports